import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { Link } from 'react-router-dom'
import { FiPhone, FiStar, FiMessageSquare } from 'react-icons/fi'
import '../style/FeedbackModal.css'

const FeedbackModal = ({ show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg" className="feedback-modal-wrapper">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="feedback-modal-title w-100 text-center">
          <h3>We value your feedback</h3>
          <div className="feedback-accent" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4">
        <p className="feedback-subtitle text-center">
          Help us serve you better. Share your thoughts, concerns, or suggestions.
        </p>

        <div className="feedback-sections">
          <div className="feedback-section">
            <div className="feedback-section-icon">
              <FiMessageSquare size={24} />
            </div>
            <div className="feedback-section-content">
              <h5>Customer Feedback</h5>
              <p>We'd love to hear about your experience with NG Eagle.</p>
              <Link to="/contact_us" className="feedback-btn" onClick={onClose}>
                Submit Feedback
              </Link>
            </div>
          </div>

          <div className="feedback-section">
            <div className="feedback-section-icon">
              <FiPhone size={24} />
            </div>
            <div className="feedback-section-content">
              <h5>Contact Center</h5>
              <p>Call us directly for any assistance.</p>
              <div className="feedback-contact-info">
                <a href="tel:+2347032205576" className="feedback-btn">+234 703 220 5576</a>
              </div>
            </div>
          </div>

          <div className="feedback-section">
            <div className="feedback-section-icon">
              <FiStar size={24} />
            </div>
            <div className="feedback-section-content">
              <h5>Evaluate Our Website</h5>
              <p>Tell us how we can improve your online experience.</p>
              <Link to="/contact_us" className="feedback-btn" onClick={onClose}>
                Share Your Opinion
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default FeedbackModal
